var React = require('react');

function IconNPS (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M536.24 622.41a258.52 258.52 0 0 0 83.25-89.18c7.57-12.74 0-27.08-13.24-33.45-15.14-6.36-32.17 0-39.73 11.15a215.87 215.87 0 0 1-66.22 70.1c-26.49 15.93-56.76 25.48-85.13 25.48a155 155 0 0 1-85.14-25.48 215.87 215.87 0 0 1-66.22-70.07c-7.57-12.74-24.59-17.51-39.73-11.15s-20.81 20.71-13.24 33.45a258.59 258.59 0 0 0 83.24 89.18c36 23.89 77.57 35 121.09 35s85.13-11.14 121.07-35.03zM269.75 256.27c-34.58 0-62.25 26.74-62.25 60.17s27.67 60.18 62.25 60.18S332 349.88 332 316.44s-27.67-60.17-62.25-60.17zM560.24 256.27c-34.58 0-62.24 26.74-62.24 60.17s27.66 60.18 62.24 60.18 62.26-26.74 62.26-60.18-27.67-60.17-62.26-60.17z","key":0}),React.createElement("path",{"d":"M415 .03C185.8.03 0 185.84 0 415.03s185.8 415 415 415 415-185.81 415-415S644.2.03 415 .03zm0 788.56c-206.28 0-373.5-167.23-373.5-373.53S208.72 41.53 415 41.53s373.49 167.2 373.49 373.5S621.27 788.56 415 788.56z","key":1})]);
}

IconNPS.displayName = "IconNPS";

IconNPS.defaultProps = {"data-name":"图层 1","viewBox":"0 0 829.99 830.07"};

module.exports = IconNPS;

IconNPS.default = IconNPS;
